export { default as DiscordPresenceClassesDefault } from './DiscordPresenceDefault.module.css';
export { default as DiscordPresenceClassesCode } from './DiscordPresenceCode.module.css';
